import type { ShipBlueprint } from "../ship";

export const JUNKER_01: ShipBlueprint = {
  name: "Junker-01",
  modules: [
    { defId: "radiator_mk1", gx: 4, gy: -3 },
    { defId: "conductivity_beam_2x1", gx: 4, gy: -1, facing: 1 },
    { defId: "docking_collar_mk1", gx: 6, gy: -1, facing: 3 },
    { defId: "rcs_quad", gx: 9, gy: -1 },
    { defId: "thruster_chem_mk1", gx: 1, gy: 0 },
    { defId: "rcs_quad", gx: 2, gy: 0 },
    { defId: "radar_passive_mk1", gx: 6, gy: 0 },
    { defId: "life_support_mk1", gx: 7, gy: 0 },
    { defId: "insulation_plate_mk1", gx: 8, gy: 0 },
    { defId: "thruster_chem_mk1", gx: 9, gy: 0, facing: 2 },
    { defId: "thruster_chem_mk1", gx: 1, gy: 1 },
    { defId: "radiator_mk1", gx: 2, gy: 1 },
    { defId: "fission_mk1", gx: 3, gy: 1 },
    { defId: "insulation_plate_mk1", gx: 5, gy: 1 },
    { defId: "fuel_tank_mk1", gx: 6, gy: 1, facing: 1 },
    { defId: "cargo_pod_mk1", gx: 7, gy: 1 },
    { defId: "radiator_mk1", gx: 8, gy: 1 },
    { defId: "cockpit_mk1", gx: 9, gy: 1 },
    { defId: "pdc_mk1", gx: 10, gy: 1 },
    { defId: "thruster_chem_mk1", gx: 1, gy: 2 },
    { defId: "insulation_plate_mk1", gx: 5, gy: 2 },
    { defId: "cargo_pod_mk1", gx: 7, gy: 2 },
    { defId: "mining_laser_mk1", gx: 9, gy: 2 },
    { defId: "thruster_chem_mk1", gx: 1, gy: 3 },
    { defId: "rcs_quad", gx: 2, gy: 3 },
    { defId: "conductivity_beam_2x1", gx: 4, gy: 3, facing: 1 },
    { defId: "antenna_mk1", gx: 6, gy: 3, facing: 1 },
    { defId: "crew_quarters_mk1", gx: 7, gy: 3 },
    { defId: "insulation_plate_mk1", gx: 8, gy: 3 },
    { defId: "thruster_chem_mk1", gx: 9, gy: 3, facing: 2 },
    { defId: "docking_collar_mk1", gx: 6, gy: 4, facing: 1 },
    { defId: "crew_quarters_mk1", gx: 7, gy: 4 },
    { defId: "rcs_quad", gx: 9, gy: 4 },
    { defId: "radiator_mk1", gx: 4, gy: 5 },
  ],
  conduits: [
    { sgx: 26, sgy: -1, type: "universal" },
    { sgx: 37, sgy: -1, type: "universal" },
    { sgx: 26, sgy: 0, type: "universal" },
    { sgx: 37, sgy: 0, type: "universal" },
    { sgx: 26, sgy: 1, type: "universal" },
    { sgx: 37, sgy: 1, type: "universal" },
    { sgx: 26, sgy: 2, type: "universal" },
    { sgx: 27, sgy: 2, type: "universal" },
    { sgx: 28, sgy: 2, type: "universal" },
    { sgx: 29, sgy: 2, type: "universal" },
    { sgx: 30, sgy: 2, type: "universal" },
    { sgx: 31, sgy: 2, type: "universal" },
    { sgx: 32, sgy: 2, type: "universal" },
    { sgx: 33, sgy: 2, type: "universal" },
    { sgx: 34, sgy: 2, type: "universal" },
    { sgx: 35, sgy: 2, type: "universal" },
    { sgx: 36, sgy: 2, type: "universal" },
    { sgx: 37, sgy: 2, type: "universal" },
    { sgx: 6, sgy: 3, type: "universal" },
    { sgx: 10, sgy: 3, type: "universal" },
    { sgx: 27, sgy: 3, type: "universal" },
    { sgx: 37, sgy: 3, type: "universal" },
    { sgx: 6, sgy: 4, type: "universal" },
    { sgx: 10, sgy: 4, type: "universal" },
    { sgx: 26, sgy: 4, type: "universal" },
    { sgx: 27, sgy: 4, type: "universal" },
    { sgx: 37, sgy: 4, type: "universal" },
    { sgx: 6, sgy: 5, type: "universal" },
    { sgx: 10, sgy: 5, type: "universal" },
    { sgx: 26, sgy: 5, type: "universal" },
    { sgx: 37, sgy: 5, type: "universal" },
    { sgx: 38, sgy: 5, type: "universal" },
    { sgx: 39, sgy: 5, type: "universal" },
    { sgx: 40, sgy: 5, type: "universal" },
    { sgx: 6, sgy: 6, type: "universal" },
    { sgx: 10, sgy: 6, type: "universal" },
    { sgx: 26, sgy: 6, type: "universal" },
    { sgx: 37, sgy: 6, type: "universal" },
    { sgx: 6, sgy: 7, type: "universal" },
    { sgx: 10, sgy: 7, type: "universal" },
    { sgx: 19, sgy: 7, type: "universal" },
    { sgx: 20, sgy: 7, type: "universal" },
    { sgx: 22, sgy: 7, type: "universal" },
    { sgx: 23, sgy: 7, type: "universal" },
    { sgx: 24, sgy: 7, type: "universal" },
    { sgx: 25, sgy: 7, type: "universal" },
    { sgx: 26, sgy: 7, type: "universal" },
    { sgx: 27, sgy: 7, type: "universal" },
    { sgx: 28, sgy: 7, type: "universal" },
    { sgx: 29, sgy: 7, type: "universal" },
    { sgx: 30, sgy: 7, type: "universal" },
    { sgx: 31, sgy: 7, type: "universal" },
    { sgx: 32, sgy: 7, type: "universal" },
    { sgx: 37, sgy: 7, type: "universal" },
    { sgx: 6, sgy: 8, type: "universal" },
    { sgx: 7, sgy: 8, type: "universal" },
    { sgx: 8, sgy: 8, type: "universal" },
    { sgx: 9, sgy: 8, type: "universal" },
    { sgx: 10, sgy: 8, type: "universal" },
    { sgx: 11, sgy: 8, type: "universal" },
    { sgx: 12, sgy: 8, type: "universal" },
    { sgx: 20, sgy: 8, type: "universal" },
    { sgx: 21, sgy: 8, type: "universal" },
    { sgx: 22, sgy: 8, type: "universal" },
    { sgx: 37, sgy: 8, type: "universal" },
    { sgx: 6, sgy: 9, type: "universal" },
    { sgx: 10, sgy: 9, type: "universal" },
    { sgx: 37, sgy: 9, type: "universal" },
    { sgx: 6, sgy: 10, type: "universal" },
    { sgx: 10, sgy: 10, type: "universal" },
    { sgx: 17, sgy: 10, type: "heat", facing: 2 },
    { sgx: 18, sgy: 10, type: "heat", facing: 2 },
    { sgx: 19, sgy: 10, type: "heat", facing: 2 },
    { sgx: 20, sgy: 10, type: "heat", facing: 2 },
    { sgx: 21, sgy: 10, type: "heat", facing: 2 },
    { sgx: 22, sgy: 10, type: "heat", facing: 2 },
    { sgx: 23, sgy: 10, type: "heat", facing: 2 },
    { sgx: 24, sgy: 10, type: "heat", facing: 2 },
    { sgx: 25, sgy: 10, type: "heat", facing: 2 },
    { sgx: 26, sgy: 10, type: "heat", facing: 2 },
    { sgx: 27, sgy: 10, type: "heat", facing: 2 },
    { sgx: 28, sgy: 10, type: "heat", facing: 2 },
    { sgx: 29, sgy: 10, type: "heat", facing: 2 },
    { sgx: 30, sgy: 10, type: "heat", facing: 2 },
    { sgx: 31, sgy: 10, type: "heat", facing: 2 },
    { sgx: 32, sgy: 10, type: "heat", facing: 2 },
    { sgx: 37, sgy: 10, type: "universal" },
    { sgx: 6, sgy: 11, type: "universal" },
    { sgx: 10, sgy: 11, type: "universal" },
    { sgx: 37, sgy: 11, type: "universal" },
    { sgx: 6, sgy: 12, type: "universal" },
    { sgx: 10, sgy: 12, type: "universal" },
    { sgx: 37, sgy: 12, type: "universal" },
    { sgx: 37, sgy: 13, type: "universal" },
    { sgx: 26, sgy: 14, type: "universal" },
    { sgx: 27, sgy: 14, type: "universal" },
    { sgx: 28, sgy: 14, type: "universal" },
    { sgx: 29, sgy: 14, type: "universal" },
    { sgx: 30, sgy: 14, type: "universal" },
    { sgx: 31, sgy: 14, type: "universal" },
    { sgx: 32, sgy: 14, type: "universal" },
    { sgx: 33, sgy: 14, type: "universal" },
    { sgx: 34, sgy: 14, type: "universal" },
    { sgx: 35, sgy: 14, type: "universal" },
    { sgx: 36, sgy: 14, type: "universal" },
    { sgx: 37, sgy: 14, type: "universal" },
    { sgx: 26, sgy: 15, type: "universal" },
    { sgx: 36, sgy: 15, type: "universal" },
    { sgx: 26, sgy: 16, type: "universal" },
    { sgx: 36, sgy: 16, type: "universal" },
    { sgx: 26, sgy: 17, type: "universal" },
    { sgx: 36, sgy: 17, type: "universal" },
  ],
};
